// GERADO automaticamente da migração do blog WordPress. Não editar à mão.
// Corpo de cada post: public/content/{slug}.html (carregado sob demanda).
export const posts = [
  {
    "id": 7717,
    "slug": "como-a-gestao-de-vendas-com-crm-pode-impulsionar-os-resultados-da-sua-loteadora",
    "title": "Como a gestão de vendas com CRM pode impulsionar os resultados da sua loteadora",
    "date": "2025-09-28",
    "excerpt": "No setor imobiliário, especialmente para loteadoras, o cenário competitivo exige cada vez mais agilidade, assertividade e controle. Quem não adota soluções tecnológicas integradas acaba perdendo oport",
    "cover": "/wp-content/uploads/2026/09/gestao-vendas-crm-loteadora.jpg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Economia",
        "slug": "economia"
      },
      {
        "name": "Imóveis de Luxo",
        "slug": "imoveis-de-luxo"
      },
      {
        "name": "Interatividade",
        "slug": "interatividade"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Marketing Construtoras",
        "slug": "marketing-construtoras"
      },
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Pós-vendas",
        "slug": "pos-vendas"
      },
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Como a gestão de vendas com CRM pode impulsionar os resultados da sua loteadora | IMOBMEET",
    "seoDesc": "No setor imobiliário, especialmente para loteadoras, o cenário competitivo exige cada vez mais agilidade, assertividade e controle."
  },
  {
    "id": 7701,
    "slug": "50-dicas-para-otimizar-a-abordagem-comercial-na-venda-de-imoveis",
    "title": "50 Dicas para Otimizar a Abordagem Comercial na Venda de Imóveis",
    "date": "2025-09-18",
    "excerpt": "Estratégia e planejamento Conheça bem seu público-alvo — tipo de cliente, faixa de renda, desejos, dores e objeções. Segmentação de mercado — especialize-se em nichos (familias, investidores, imóveis ",
    "cover": "/wp-content/uploads/2024/03/AdobeStock_609874091-scaled.jpeg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Marketing Construtoras",
        "slug": "marketing-construtoras"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "50 Dicas para Otimizar a Abordagem Comercial na Venda de Imóveis | IMOBMEET",
    "seoDesc": "Essas 50 dicas se implantadas na sua empresa, podem trazer um novo cenário comercial para os seus resultados."
  },
  {
    "id": 7678,
    "slug": "erp-uau-senior-sistemas-entenda-tudo",
    "title": "ERP UAU Sênior Sistemas &#8211; Entenda tudo.",
    "date": "2025-09-17",
    "excerpt": "O ERP UAU, da Senior Sistemas (resultado da aquisição da Globaltec), é uma solução voltada especialmente para o mercado de construção civil, loteamento, incorporação e urbanização. Seu objetivo é acom",
    "cover": "/wp-content/uploads/2026/09/erp-financeiro-sistemas.jpg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Marketing Construtoras",
        "slug": "marketing-construtoras"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "ERP UAU Sênior Sistemas - Entenda tudo. | IMOBMEET",
    "seoDesc": "O ERP UAU, da Senior Sistemas, é uma solução para gestão de obras e incorporação. Entenda seus módulos, recursos e como integrá-lo ao seu CRM imobiliário."
  },
  {
    "id": 7658,
    "slug": "steel-frame-na-construcao-civil-brasileira-vantagens-diferenciais-desafios-e-comparacao-com-outros-metodos-construtivos",
    "title": "Steel Frame na Construção Civil Brasileira: Vantagens, Diferenciais, Desafios e Comparação com Outros Métodos Construtivos",
    "date": "2025-09-16",
    "excerpt": "Introdução Nos últimos anos, a construção civil brasileira vem passando por uma transformação marcada pela busca por maior eficiência, redução de custos, rapidez de execução e sustentabilidade. A pres",
    "cover": "/wp-content/uploads/2025/09/steel-frame.jpg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Marketing Construtoras",
        "slug": "marketing-construtoras"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Steel Frame na Construção Civil Brasileira: Vantagens, Diferenciais, Desafios e Comparação com Outros Métodos Construtivos | IMOBMEET",
    "seoDesc": "Este artigo apresenta uma análise detalhada sobre o Steel Frame, suas vantagens, diferenciais, desafios e uma comparação direta com os métodos construtivos mais utilizados no Brasil."
  },
  {
    "id": 7645,
    "slug": "mercado-imobiliario-2025-como-os-juros-altos-e-o-credito-caro-estao-redesenhando-as-vendas-e-os-lancamentos-no-brasil",
    "title": "Mercado Imobiliário 2025: Como os Juros Altos e o Crédito Caro Estão Redesenhando as Vendas e os Lançamentos no Brasil",
    "date": "2025-09-15",
    "excerpt": "Introdução O mercado imobiliário brasileiro sempre foi altamente sensível ao cenário econômico, especialmente às taxas de juros e ao acesso ao crédito. Nos últimos três meses, o setor tem vivido uma c",
    "cover": "/wp-content/uploads/2023/08/vert.jpg",
    "categories": [
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Inteligência Artificial",
        "slug": "inteligencia-artificial"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Marketing Construtoras",
        "slug": "marketing-construtoras"
      },
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Mercado Imobiliário 2025: Como os Juros Altos e o Crédito Caro Estão Redesenhando as Vendas e os Lançamentos no Brasil | IMOBMEET",
    "seoDesc": "A tendência é que o mercado imobiliário siga em estabilidade moderada até que haja uma sinalização clara de queda nos juros."
  },
  {
    "id": 7629,
    "slug": "6-aplicacoes-urgentes-de-inteligencia-artificial-para-incorporadoras-e-loteadoras",
    "title": "6 Aplicações urgentes de inteligência artificial para incorporadoras e Loteadoras",
    "date": "2025-08-24",
    "excerpt": "Introdução O setor imobiliário sempre foi marcado por grandes investimentos, negociações complexas e ciclos de venda longos. Incorporadoras e loteadoras, em especial, enfrentam desafios como prever a ",
    "cover": "/wp-content/uploads/2025/08/tipos-de-inteligencia-artificial-FCamara-1.jpg",
    "categories": [
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Inteligência Artificial",
        "slug": "inteligencia-artificial"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Marketing Construtoras",
        "slug": "marketing-construtoras"
      },
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "6 Aplicações urgentes de inteligência artificial para incorporadoras e Loteadoras | IMOBMEET",
    "seoDesc": "Essas são as aplicações mais urgentes de inteligência artificial para implementar na sua incorporadora ou loteadora."
  },
  {
    "id": 7140,
    "slug": "os-10-maiores-desafios-de-vendas-de-loteadores-no-mercado-imobiliario",
    "title": "Os 10 Maiores Desafios de Vendas de Loteadores no Mercado Imobiliário",
    "date": "2025-06-19",
    "excerpt": "O mercado de loteamentos continua em expansão no Brasil, principalmente em cidades de médio porte e regiões de crescimento urbano. No entanto, apesar da demanda por moradia e o apelo dos terrenos como",
    "cover": "/wp-content/uploads/2026/09/desafios-vendas-loteadores.jpg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Economia",
        "slug": "economia"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Os 10 Maiores Desafios de Vendas de Loteadores no Mercado Imobiliário | IMOBMEET",
    "seoDesc": "O mercado de loteamentos continua em expansão no Brasil, principalmente em cidades de médio porte e regiões de crescimento urbano. No entanto, apesar da demanda por moradia e o apelo dos terrenos como forma de investimento ou construção própria, os loteadores enfrentam desafios significativos para realizar vendas consistentes e sustentáveis. Neste artigo, listamos os 10 [&hellip;]"
  },
  {
    "id": 7091,
    "slug": "como-otimizar-seus-resultados-utilizando-um-crm-para-incorporadoras",
    "title": "Como otimizar seus resultados utilizando um CRM para incorporadoras",
    "date": "2025-05-20",
    "excerpt": "Por que um CRM Especializado é Essencial para Incorporadoras?No dinâmico mercado imobiliário, a adoção de um sistema de CRM específico para incorporadoras tornou-sefundamental. Essa ferramenta permite",
    "cover": "/wp-content/uploads/2025/05/integracoes-crm-imobmeet.png",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Economia",
        "slug": "economia"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Como otimizar seus resultados utilizando um CRM para incorporadoras | IMOBMEET",
    "seoDesc": "Por que um CRM Especializado é Essencial para Incorporadoras?No dinâmico mercado imobiliário, a adoção de um sistema de CRM específico para incorporadoras tornou-sefundamental. Essa ferramenta permite não apenas a organização eficiente dos processos de vendas, mastambém o fortalecimento do relacionamento com os clientes, desde o primeiro contato até o pós-venda. Benefícios de um CRM para [&hellip;]"
  },
  {
    "id": 6779,
    "slug": "como-organizar-a-gestao-da-sua-loteadora",
    "title": "Como organizar a gestão da sua Loteadora",
    "date": "2025-05-13",
    "excerpt": "A gestão de uma loteadora envolve desafios complexos que vão desde o planejamento estratégico até o relacionamento com o cliente. Para se destacar em um mercado cada vez mais competitivo, é essencial ",
    "cover": "/wp-content/uploads/2026/09/organizar-gestao-loteadora.jpg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Economia",
        "slug": "economia"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Como organizar a gestão da sua Loteadora | IMOBMEET",
    "seoDesc": "A gestão de uma loteadora envolve desafios complexos que vão desde o planejamento estratégico até o relacionamento com o cliente. Para se destacar em um mercado cada vez mais competitivo, é essencial adotar práticas modernas e ferramentas tecnológicas que otimizem processos e melhorem a experiência do cliente. Planejamento Estratégico e Análise de Mercado O primeiro [&hellip;]"
  },
  {
    "id": 6776,
    "slug": "crm-de-vendas-aplicado-a-gestao-de-incorporadoras-e-loteadoras",
    "title": "CRM de vendas aplicado à Gestão de Incorporadoras e Loteadoras",
    "date": "2025-05-13",
    "excerpt": "CRM Aplicado à Gestão de Incorporadoras e Loteadoras: Transformando Vendas com Tecnologia No competitivo mercado imobiliário, incorporadoras e loteadoras enfrentam o desafio constante de otimizar suas",
    "cover": "/wp-content/uploads/2026/09/crm-vendas-incorporadoras-loteadoras.jpg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Economia",
        "slug": "economia"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "CRM de vendas aplicado à Gestão de Incorporadoras e Loteadoras | IMOBMEET",
    "seoDesc": "CRM Aplicado à Gestão de Incorporadoras e Loteadoras: Transformando Vendas com Tecnologia No competitivo mercado imobiliário, incorporadoras e loteadoras enfrentam o desafio constante de otimizar suas operações de vendas, melhorar o relacionamento com clientes e aumentar a eficiência dos processos. Nesse cenário, a adoção de sistemas de CRM (Customer Relationship Management) torna-se essencial para alcançar [&hellip;]"
  },
  {
    "id": 5676,
    "slug": "o-que-a-selic-e-a-inflacao-realmente-interferem-no-mercado-imobiliario",
    "title": "O que a SELIC e a INFLAÇÃO realmente interferem no mercado imobiliário",
    "date": "2023-08-28",
    "excerpt": "O mercado imobiliário é um dos setores mais influentes e representativos da economia de um país. Seu comportamento pode ser afetado por diversos fatores, sendo dois dos mais relevantes a taxa SELIC e ",
    "cover": "/wp-content/uploads/2023/08/taxa-selic.jpg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Economia",
        "slug": "economia"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "O que a SELIC e a INFLAÇÃO realmente interferem no mercado imobiliário | IMOBMEET",
    "seoDesc": "O mercado imobiliário é um dos setores mais influentes e representativos da economia de um país. Seu comportamento pode ser afetado por diversos fatores, sendo dois dos mais relevantes a taxa SELIC e a inflação. Mas, afinal, o que são esses dois termos e como eles impactam diretamente no mercado de imóveis? Vamos entender. O [&hellip;]"
  },
  {
    "id": 5666,
    "slug": "como-criar-seu-estande-online-de-imoveis-100-integrado-ao-seu-crm-de-vendas",
    "title": "IMOBMEET Autovendas: como vender unidades 100% online integrado ao CRM",
    "date": "2023-08-22",
    "excerpt": "Venda apartamentos e lotes em uma jornada 100% online — do cadastro ao pagamento — com estoque sincronizado ao CRM, dois canais de venda e pagamento via Pix, boleto ou cartão.",
    "cover": "/wp-content/uploads/2023/03/imovel-de-luxo.jpg",
    "categories": [
      {
        "name": "Vendas",
        "slug": "vendas"
      },
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      }
    ],
    "seoTitle": "IMOBMEET Autovendas: como vender unidades 100% online | IMOBMEET",
    "seoDesc": "Venda unidades 100% online com o IMOBMEET Autovendas: jornada em 6 passos, link por corretor com comissão automática, estoque em tempo real e pagamento via Pix, boleto ou cartão."
  },
  {
    "id": 5659,
    "slug": "qual-a-diferenca-entre-loteadoras-e-incorporadoras",
    "title": "Qual a diferença entre Loteadoras e Incorporadoras?",
    "date": "2023-08-18",
    "excerpt": "O mercado imobiliário é vasto e diversificado, e entre os muitos agentes que atuam neste setor, as loteadoras e incorporadoras são duas das mais proeminentes. Embora muitas vezes sejam confundidas ou ",
    "cover": "/wp-content/uploads/2026/09/diferenca-loteadoras-incorporadoras.jpg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      }
    ],
    "seoTitle": "Qual a diferença entre Loteadoras e Incorporadoras? | IMOBMEET",
    "seoDesc": "O mercado imobiliário é vasto e diversificado, e entre os muitos agentes que atuam neste setor, as loteadoras e incorporadoras são duas das mais proeminentes. Embora muitas vezes sejam confundidas ou usadas de forma intercambiável, essas entidades têm funções distintas e são regidas por regulamentações específicas. Entender a diferença entre elas é fundamental para quem [&hellip;]"
  },
  {
    "id": 5662,
    "slug": "a-jornada-de-compra-de-um-imovel-100-online-com-tudo-em-um-unico-lugar",
    "title": "Jornada de compra de imóvel 100% online: como funciona na prática",
    "date": "2023-08-16",
    "excerpt": "O comprador de imóvel mudou. Entenda como funciona a jornada de compra 100% online — do cadastro ao pagamento em um único lugar — e o novo papel do corretor.",
    "cover": "/wp-content/uploads/2023/08/VENDAS-ONLINE-1.jpg",
    "categories": [
      {
        "name": "Vendas",
        "slug": "vendas"
      },
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      }
    ],
    "seoTitle": "Jornada de Compra de Imóvel 100% Online: como funciona | IMOBMEET",
    "seoDesc": "Como funciona a jornada de compra de imóvel 100% online: as 6 etapas, do cadastro ao pagamento em um único lugar, com estoque em tempo real e comissão automática por corretor."
  },
  {
    "id": 5656,
    "slug": "12-tendencias-de-inovacao-para-voce-ficar-atualizado",
    "title": "12 Tendências de inovação para você ficar atualizado",
    "date": "2023-08-16",
    "excerpt": "Nós não podemos prever o futuro, mas com base nas tendências emergentes e na direção geral da tecnologia e inovação, podemos especular algumas tendências que podem e estão sendo relevantes em 2023. Al",
    "cover": "/wp-content/uploads/2023/08/My-project-5.png",
    "categories": [
      {
        "name": "Inovação",
        "slug": "inovacao"
      },
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      }
    ],
    "seoTitle": "12 Tendências de inovação para você ficar atualizado | IMOBMEET",
    "seoDesc": "Nós não podemos prever o futuro, mas com base nas tendências emergentes e na direção geral da tecnologia e inovação, podemos especular algumas tendências que podem e estão sendo relevantes em 2023. Algumas potenciais tendências de inovação podem incluir: A realidade em 2023 pode ter novas tendências e inovações que não foram antecipadas anteriormente. Para [&hellip;]"
  },
  {
    "id": 5639,
    "slug": "o-que-e-e-como-aplicar-automacao-de-marketing-e-vendas",
    "title": "O que é, e como aplicar automação de marketing e vendas?",
    "date": "2023-07-03",
    "excerpt": "A automação de marketing refere-se ao uso de tecnologia e software para automatizar e otimizar as atividades de marketing. É um conjunto de ferramentas e estratégias que permitem a automação de tarefa",
    "cover": "/wp-content/uploads/2023/06/automacao-de-mkt-e-vendas.jpeg",
    "categories": [
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "O que é, e como aplicar automação de marketing e vendas? | IMOBMEET",
    "seoDesc": "A automação de marketing refere-se ao uso de tecnologia e software para automatizar e otimizar as atividades de marketing. É um conjunto de ferramentas e estratégias que permitem a automação de tarefas repetitivas e a criação de fluxos de trabalho eficientes, com o objetivo de atrair, nutrir e converter leads em clientes. Ao aplicar a [&hellip;]"
  },
  {
    "id": 5636,
    "slug": "7-tecnologias-de-interatividade-para-aplicar-no-mercado-imobiliario",
    "title": "7 Tecnologias de interatividade para aplicar no mercado imobiliário",
    "date": "2023-06-28",
    "excerpt": "Essas são apenas algumas das tecnologias de interatividade que estão sendo aplicadas no mercado imobiliário. A adoção dessas inovações pode ajudar a melhorar a experiência dos clientes, agilizar proce",
    "cover": "/wp-content/uploads/2023/06/realidade-aumentada-educacao-1.jpg",
    "categories": [
      {
        "name": "Apresentação de imóveis online",
        "slug": "apresentacao-de-imoveis-online"
      },
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Interatividade",
        "slug": "interatividade"
      }
    ],
    "seoTitle": "7 Tecnologias de interatividade para aplicar no mercado imobiliário | IMOBMEET",
    "seoDesc": "Essas são apenas algumas das tecnologias de interatividade que estão sendo aplicadas no mercado imobiliário. A adoção dessas inovações pode ajudar a melhorar a experiência dos clientes, agilizar processos e impulsionar os negócios no setor imobiliário. Dica extra: Apresente e venda imóveis 100% online.Conheça o&nbsp;IMOBMEET&nbsp;uma plataforma de Plantão Digital integrada às melhores ferramentas de Marketing [&hellip;]"
  },
  {
    "id": 5562,
    "slug": "como-vender-imoveis-e-se-destacar-no-mercado-imobiliario-passo-a-passo",
    "title": "Como vender imóveis e se destacar no mercado imobiliário: passo a passo",
    "date": "2023-04-26",
    "excerpt": "Vender imóveis e se destacar no mercado imobiliário requer dedicação, habilidades e estratégias eficazes. Aqui estão alguns passos importantes que podem ajudá-lo a se destacar no mercado imobiliário e",
    "cover": "/wp-content/uploads/2023/04/vender-imoveis.jpeg",
    "categories": [
      {
        "name": "Marketing Construtoras",
        "slug": "marketing-construtoras"
      }
    ],
    "seoTitle": "Como vender imóveis e se destacar no mercado imobiliário: passo a passo | IMOBMEET",
    "seoDesc": "Vender imóveis e se destacar no mercado imobiliário requer dedicação, habilidades e estratégias eficazes. Aqui estão alguns passos importantes que podem ajudá-lo a se destacar no mercado imobiliário e vender imóveis com sucesso: Dica extra: Apresente e venda imóveis 100% online.Conheça o&nbsp;IMOBMEET&nbsp;uma plataforma de Plantão Digital integrada às melhores ferramentas de Marketing e vendas. Conheça [&hellip;]"
  },
  {
    "id": 5559,
    "slug": "marketing-para-construtoras",
    "title": "Marketing para Construtoras",
    "date": "2023-04-24",
    "excerpt": "Marketing para construtoras é o conjunto de estratégias, táticas e ações que visam promover empreendimentos imobiliários para potenciais compradores, além de criar e consolidar a marca da construtora ",
    "cover": "/wp-content/uploads/2023/04/marketing-construtoras.webp",
    "categories": [
      {
        "name": "Marketing Construtoras",
        "slug": "marketing-construtoras"
      }
    ],
    "seoTitle": "Marketing para Construtoras | IMOBMEET",
    "seoDesc": "Marketing para construtoras é o conjunto de estratégias, táticas e ações que visam promover empreendimentos imobiliários para potenciais compradores, além de criar e consolidar a marca da construtora no mercado imobiliário. O marketing pode alavancar as vendas nos lançamentos porque, ao aplicar estratégias adequadas, a construtora pode chegar ao público-alvo correto e mostrar os benefícios [&hellip;]"
  },
  {
    "id": 5550,
    "slug": "50-dicas-para-diferenciar-sua-imobiliaria-dos-concorrentes",
    "title": "50 dicas para diferenciar sua imobiliária dos concorrentes",
    "date": "2023-04-20",
    "excerpt": "Dica extra: Apresente e venda imóveis 100% online.Conheça o&nbsp;IMOBMEET&nbsp;uma plataforma de Plantão Digital integrada às melhores ferramentas de Marketing e vendas. Conheça o imobmeet,&nbsp;cliqu",
    "cover": "/wp-content/uploads/2023/04/imobiliarias-de-sucesso.jpeg",
    "categories": [
      {
        "name": "Imobiliárias",
        "slug": "imobiliarias"
      }
    ],
    "seoTitle": "50 dicas para diferenciar sua imobiliária dos concorrentes | IMOBMEET",
    "seoDesc": "Dica extra: Apresente e venda imóveis 100% online.Conheça o&nbsp;IMOBMEET&nbsp;uma plataforma de Plantão Digital integrada às melhores ferramentas de Marketing e vendas. Conheça o imobmeet,&nbsp;clique aqui"
  },
  {
    "id": 5553,
    "slug": "como-serao-as-imobiliarias-do-futuro-10-caracteristicas-principais-2",
    "title": "Como serão as imobiliárias do futuro: 10 Características principais",
    "date": "2023-04-18",
    "excerpt": "As imobiliárias do futuro serão muito diferentes das imobiliárias que conhecemos hoje. Isso porque o mercado imobiliário está mudando rapidamente e se adaptando às novas tecnologias e tendências. Uma ",
    "cover": "/wp-content/uploads/2023/04/imobiliarias-do-futuro.jpeg",
    "categories": [
      {
        "name": "Imobiliárias",
        "slug": "imobiliarias"
      }
    ],
    "seoTitle": "Como serão as imobiliárias do futuro: 10 Características principais | IMOBMEET",
    "seoDesc": "As imobiliárias do futuro serão muito diferentes das imobiliárias que conhecemos hoje. Isso porque o mercado imobiliário está mudando rapidamente e se adaptando às novas tecnologias e tendências. Uma das principais tendências é a apresentação de imóveis online e a criação de plantão digital de atendimento online. A apresentação de imóveis online é uma tendência [&hellip;]"
  },
  {
    "id": 5538,
    "slug": "o-que-e-e-quais-os-diferenciais-do-wood-frame-na-construcao-civil",
    "title": "O que é, e quais os diferenciais do Wood Frame na construção civil",
    "date": "2023-04-14",
    "excerpt": "O wood frame é uma técnica de construção civil que tem ganhado cada vez mais espaço no mercado brasileiro. Trata-se de um sistema construtivo que utiliza a madeira como principal matéria-prima, combin",
    "cover": "/wp-content/uploads/2023/04/wood-frame.jpeg",
    "categories": [
      {
        "name": "Construção Civil",
        "slug": "construcao-civil"
      }
    ],
    "seoTitle": "O que é, e quais os diferenciais do Wood Frame na construção civil | IMOBMEET",
    "seoDesc": "O wood frame é uma técnica de construção civil que tem ganhado cada vez mais espaço no mercado brasileiro. Trata-se de um sistema construtivo que utiliza a madeira como principal matéria-prima, combinando tecnologia e sustentabilidade para criar estruturas de alta qualidade e durabilidade. Uma das principais vantagens do wood frame é a rapidez na execução [&hellip;]"
  },
  {
    "id": 5525,
    "slug": "o-que-e-short-stay-e-como-funciona",
    "title": "O que é Short Stay e como Funciona?",
    "date": "2023-04-12",
    "excerpt": "Nos últimos anos, tem se tornado cada vez mais comum o aluguel de apartamentos por períodos curtos, geralmente de algumas horas até algumas semanas. Esse tipo de aluguel é conhecido como Short Stay ou",
    "cover": "/wp-content/uploads/2023/04/short-stay.jpeg",
    "categories": [
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "O que é Short Stay e como Funciona? | IMOBMEET",
    "seoDesc": "Nos últimos anos, tem se tornado cada vez mais comum o aluguel de apartamentos por períodos curtos, geralmente de algumas horas até algumas semanas. Esse tipo de aluguel é conhecido como Short Stay ou Aluguel de Curta Duração. Mas afinal, o que é Short Stay?Basicamente, trata-se de uma modalidade de hospedagem em que o locatário [&hellip;]"
  },
  {
    "id": 5546,
    "slug": "100-frases-de-impacto-para-vender-imoveis-de-luxo",
    "title": "100 Frases de impacto para vender imóveis de luxo",
    "date": "2023-04-10",
    "excerpt": "Dica extra: Conheça o IMOBMEET CRM, uma solução de vendas completa para incorporadoras e loteadoras. clique aqui e agende uma demonstração",
    "cover": "/wp-content/uploads/2023/04/imoveis-de-luxo.png",
    "categories": [
      {
        "name": "Imóveis de Luxo",
        "slug": "imoveis-de-luxo"
      }
    ],
    "seoTitle": "100 Frases de impacto para vender imóveis de luxo | IMOBMEET",
    "seoDesc": "100 Frases de luxo para usar em conversas no mercado imobiliário seja para negociar ou apresentar um imóvel."
  },
  {
    "id": 5521,
    "slug": "10-passos-para-se-tornar-um-corretor-de-imoveis-de-alta-performance",
    "title": "10 Passos para se tornar um Corretor de Imóveis de Alta Performance",
    "date": "2023-03-30",
    "excerpt": "Dica extra: Crie seu Plantão Digital com atendimento 100% online e integrado ao seu CRM de vendas. Conheça o IMOBMEET uma plataforma de Plantão Digital, apresentação e venda de imóveis online. Conheça",
    "cover": "/wp-content/uploads/2023/03/corretor-de-imoveis.jpeg",
    "categories": [
      {
        "name": "Corretor de Imóveis",
        "slug": "corretor-de-imoveis"
      }
    ],
    "seoTitle": "10 Passos para se tornar um Corretor de Imóveis de Alta Performance | IMOBMEET",
    "seoDesc": "Dica extra: Crie seu Plantão Digital com atendimento 100% online e integrado ao seu CRM de vendas. Conheça o IMOBMEET uma plataforma de Plantão Digital, apresentação e venda de imóveis online. Conheça o imobmeet,&nbsp;clique aqui"
  },
  {
    "id": 5516,
    "slug": "15-desafios-na-hora-de-lancar-um-produto-imobiliario",
    "title": "15 desafios na hora de Lançar um Produto Imobiliário",
    "date": "2023-03-30",
    "excerpt": "Existem vários desafios associados ao lançamento de um produto imobiliário, incluindo: Dica extra: Reduza o impacto ambiental criando um stand de atendimento 100% online e integrado ao seu CRM de vend",
    "cover": "/wp-content/uploads/2023/03/view-from-the-empire-state-building-nyc-wallpaper-scaled.jpg",
    "categories": [
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      }
    ],
    "seoTitle": "15 desafios na hora de Lançar um Produto Imobiliário | IMOBMEET",
    "seoDesc": "Existem vários desafios associados ao lançamento de um produto imobiliário, incluindo: Dica extra: Reduza o impacto ambiental criando um stand de atendimento 100% online e integrado ao seu CRM de vendas. Conheça o&nbsp;IMOBMEET&nbsp;uma plataforma de Plantão Digital, apresentação e venda de imóveis online. Conheça o imobmeet,&nbsp;clique aqui"
  },
  {
    "id": 5512,
    "slug": "metaverso-o-que-e-flopou",
    "title": "Metaverso: O que é? Flopou?",
    "date": "2023-03-27",
    "excerpt": "O termo &#8220;Metaverso&#8221; foi cunhado pelo escritor de ficção científica Neal Stephenson em seu livro &#8220;Snow Crash&#8221; de 1992, e desde então tem sido usado para descrever um ambiente vi",
    "cover": "/wp-content/uploads/2023/03/meta.jpeg",
    "categories": [
      {
        "name": "Metaverso",
        "slug": "metaverso"
      }
    ],
    "seoTitle": "Metaverso: O que é? Flopou? | IMOBMEET",
    "seoDesc": "O termo &#8220;Metaverso&#8221; foi cunhado pelo escritor de ficção científica Neal Stephenson em seu livro &#8220;Snow Crash&#8221; de 1992, e desde então tem sido usado para descrever um ambiente virtual 3D persistente e expansível que é habitado por avatares, onde as pessoas podem interagir e criar conteúdo. O Metaverso é um termo que se refere [&hellip;]"
  },
  {
    "id": 5490,
    "slug": "inteligencia-artificial-tendencia-ou-modismo",
    "title": "Inteligência artificial: Tendência ou modismo?",
    "date": "2023-03-21",
    "excerpt": "Nos últimos anos, a inteligência artificial (IA) tem sido um dos temas mais comentados no mundo da tecnologia. Empresas de todos os setores estão investindo em IA para melhorar a eficiência, aumentar ",
    "cover": "/wp-content/uploads/2023/03/ia-ok.jpeg",
    "categories": [
      {
        "name": "Inteligência Artificial",
        "slug": "inteligencia-artificial"
      },
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      }
    ],
    "seoTitle": "Inteligência artificial: Tendência ou modismo? | IMOBMEET",
    "seoDesc": "Nos últimos anos, a inteligência artificial (IA) tem sido um dos temas mais comentados no mundo da tecnologia. Empresas de todos os setores estão investindo em IA para melhorar a eficiência, aumentar a produtividade e reduzir os custos. Mas, afinal, a inteligência artificial é uma tendência ou apenas um modismo passageiro? A resposta não é [&hellip;]"
  },
  {
    "id": 5487,
    "slug": "o-que-e-e-como-aplicar-conceitos-de-esg-na-sua-incorporadora",
    "title": "O que é, e como aplicar conceitos de ESG na sua incorporadora",
    "date": "2023-03-20",
    "excerpt": "O que é o ESG ? ESG é a sigla em inglês para Environmental, Social and Governance, ou seja, meio ambiente, social e governança. É um conjunto de critérios e práticas que as empresas podem adotar para ",
    "cover": "/wp-content/uploads/2023/03/esg.png",
    "categories": [
      {
        "name": "ESG",
        "slug": "esg"
      }
    ],
    "seoTitle": "O que é, e como aplicar conceitos de ESG na sua incorporadora | IMOBMEET",
    "seoDesc": "O que é o ESG ? ESG é a sigla em inglês para Environmental, Social and Governance, ou seja, meio ambiente, social e governança. É um conjunto de critérios e práticas que as empresas podem adotar para avaliar e melhorar seu desempenho em aspectos ambientais, sociais e de governança corporativa. O critério ambiental se refere [&hellip;]"
  },
  {
    "id": 5484,
    "slug": "a-importancia-do-pos-venda-no-mercado-imobiliario",
    "title": "A importância do pós-venda no mercado imobiliário",
    "date": "2023-03-17",
    "excerpt": "Fazer pós-venda no mercado imobiliário é importante por diversas razões: 1 &#8211; Fidelização do clientes Ao oferecer um bom atendimento e suporte pós-venda, você cria um vínculo de confiança e leald",
    "cover": "/wp-content/uploads/2023/03/pos-venda.jpeg",
    "categories": [
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Pós-vendas",
        "slug": "pos-vendas"
      }
    ],
    "seoTitle": "A importância do pós-venda no mercado imobiliário | IMOBMEET",
    "seoDesc": "Fazer pós-venda no mercado imobiliário é importante por diversas razões: 1 &#8211; Fidelização do clientes Ao oferecer um bom atendimento e suporte pós-venda, você cria um vínculo de confiança e lealdade com o cliente, que pode indicar seus serviços para outras pessoas e até mesmo voltar a fazer negócios com você no futuro. 2 &#8211; [&hellip;]"
  },
  {
    "id": 5463,
    "slug": "como-escolher-um-crm-de-vendas-no-mercado-imobiliario",
    "title": "Como escolher um CRM de vendas no mercado imobiliário",
    "date": "2023-03-15",
    "excerpt": "Escolher um bom CRM de vendas para o mercado imobiliário pode ser uma tarefa desafiadora, mas existem alguns pontos que você pode considerar para tomar a melhor decisão. Aqui estão algumas dicas que p",
    "cover": "/wp-content/uploads/2026/09/escolher-crm-vendas-imobiliario.jpg",
    "categories": [
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Como escolher um CRM de vendas no mercado imobiliário | IMOBMEET",
    "seoDesc": "Escolher um bom CRM de vendas para o mercado imobiliário pode ser uma tarefa desafiadora, mas existem alguns pontos que você pode considerar para tomar a melhor decisão. Aqui estão algumas dicas que podem ajudar: 1 &#8211; Identifique suas necessidades Antes de começar a procurar por um CRM, faça uma lista das funcionalidades que você [&hellip;]"
  },
  {
    "id": 5460,
    "slug": "jornada-de-venda-de-imoveis-conheca-as-etapas-e-saiba-como-otimiza-las",
    "title": "Jornada de venda de imóveis: conheça as etapas e saiba como otimizá-las",
    "date": "2023-03-13",
    "excerpt": "A jornada de venda de imóveis é um processo que envolve diversas etapas, desde a prospecção de clientes até o fechamento do negócio. Conhecer essas etapas e saber como otimizá-las pode fazer toda a di",
    "cover": "/wp-content/uploads/2023/03/direction-arrow-floor-1024x652.jpg",
    "categories": [
      {
        "name": "Apresentação de imóveis online",
        "slug": "apresentacao-de-imoveis-online"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Jornada de venda de imóveis: conheça as etapas e saiba como otimizá-las | IMOBMEET",
    "seoDesc": "A jornada de venda de imóveis é um processo que envolve diversas etapas, desde a prospecção de clientes até o fechamento do negócio. Conhecer essas etapas e saber como otimizá-las pode fazer toda a diferença para aumentar as suas vendas e melhorar os resultados da sua empresa. Confira a seguir as principais etapas da jornada [&hellip;]"
  },
  {
    "id": 5442,
    "slug": "venda-de-imoveis-de-luxo-08-erros-que-voce-nao-pode-cometer",
    "title": "Venda de imóveis de Luxo: 08 erros que você não pode cometer",
    "date": "2023-03-07",
    "excerpt": "A venda de imóveis de luxo pode ser um negócio altamente lucrativo, mas também pode ser extremamente desafiador. Cometer erros durante o processo pode ser custoso em termos financeiros e de reputação.",
    "cover": "/wp-content/uploads/2023/03/apartamento-de-luxo.jpeg",
    "categories": [
      {
        "name": "Imóveis de Luxo",
        "slug": "imoveis-de-luxo"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Venda de imóveis de Luxo: 08 erros que você não pode cometer | IMOBMEET",
    "seoDesc": "A venda de imóveis de luxo pode ser um negócio altamente lucrativo, mas também pode ser extremamente desafiador. Cometer erros durante o processo pode ser custoso em termos financeiros e de reputação. Aqui estão oito erros que você não pode cometer ao vender imóveis de luxo: 1 &#8211; Subestimar a importância de uma boa apresentação [&hellip;]"
  },
  {
    "id": 5372,
    "slug": "10-pontos-onde-o-chatgpt-pode-colaborar-na-venda-de-imoveis",
    "title": "10 pontos onde o ChatGPT pode colaborar na venda de imóveis",
    "date": "2023-03-06",
    "excerpt": "O ChatGPT pode colaborar em diversos pontos do processo de venda de imóveis, confira abaixo 10 possíveis pontos onde ele pode ajudar",
    "cover": "/wp-content/uploads/2023/02/chat-gpt.jpeg",
    "categories": [
      {
        "name": "Inteligência Artificial",
        "slug": "inteligencia-artificial"
      },
      {
        "name": "Tecnologia",
        "slug": "tecnologia"
      }
    ],
    "seoTitle": "10 pontos onde o ChatGPT pode colaborar na venda de imóveis | IMOBMEET",
    "seoDesc": "O ChatGPT pode colaborar em diversos pontos do processo de venda de imóveis, confira abaixo 10 possíveis pontos onde ele pode ajudar"
  },
  {
    "id": 5369,
    "slug": "o-que-e-e-como-estruturar-um-plantao-digital-de-imoveis",
    "title": "O que é, e como estruturar um Plantão Digital de imóveis?",
    "date": "2023-03-01",
    "excerpt": "O Plantão Digital de imóveis é uma estratégia utilizada por Incorporadoras e imobiliárias para atrair clientes interessados em adquirir, por meio de canais digitais com atendimento em tempo real, onde",
    "cover": "/wp-content/uploads/2022/12/Imagem_Atendimento.webp",
    "categories": [
      {
        "name": "Apresentação de imóveis online",
        "slug": "apresentacao-de-imoveis-online"
      },
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      }
    ],
    "seoTitle": "O que é, e como estruturar um Plantão Digital de imóveis? | IMOBMEET",
    "seoDesc": "O Plantão Digital de imóveis é uma estratégia utilizada por Incorporadoras e imobiliárias para atrair clientes interessados em adquirir, por meio de canais digitais com atendimento em tempo real, onde o cliente não precisa aguardar uma ligação ou conversar eternamente com um chatbot."
  },
  {
    "id": 5363,
    "slug": "07-dicas-para-pre-atendimento-no-mercado-imobiliario",
    "title": "07 Dicas para pré-atendimento no mercado imobiliário",
    "date": "2023-02-27",
    "excerpt": "Um pré-atendimento de leads bem estruturado pode aumentar muito a sua taxa de conversão.",
    "cover": "/wp-content/uploads/2023/02/pre.png",
    "categories": [
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "07 Dicas para pré-atendimento no mercado imobiliário | IMOBMEET",
    "seoDesc": "Um pré-atendimento de leads bem estruturado pode aumentar muito a sua taxa de conversão."
  },
  {
    "id": 5238,
    "slug": "07-fatos-importantes-que-voce-precisa-saber-antes-de-lancar-seu-empreendimento-imobiliario",
    "title": "07 Fatos importantes que você precisa saber antes de lançar seu empreendimento imobiliário.",
    "date": "2023-02-15",
    "excerpt": "",
    "cover": "/wp-content/uploads/2023/02/lancamento-imobiliario.jpeg",
    "categories": [
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "07 Fatos importantes que você precisa saber antes de lançar seu empreendimento imobiliário. | IMOBMEET",
    "seoDesc": "Você precisa ler sobre estes 7 fatos antes de lançar seu empreendimento imobiliário."
  },
  {
    "id": 5231,
    "slug": "como-vender-imoveis-online-em-2023",
    "title": "Como vender imóveis online em 2023?",
    "date": "2023-02-14",
    "excerpt": "O mercado imobiliário está passando por uma evolução gigantesca, e não é somente na forma de apresentar e vender imóveis, na tecnologia construtiva também. Uma pergunta que incorporadas estão fazendo ",
    "cover": "/wp-content/uploads/2023/02/vender-imoveis-online.webp",
    "categories": [
      {
        "name": "Apresentação de imóveis online",
        "slug": "apresentacao-de-imoveis-online"
      },
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      }
    ],
    "seoTitle": "Como vender imóveis online em 2023?",
    "seoDesc": "Uma grande parte dos imóveis vendidos nos últimos 2 anos foram à distância, ou seja, o cliente não colocou os pés no estande de vendas ou decorado.E isso implica em uma nova possibilidade: A venda on-line de uma unidade imobiliária."
  },
  {
    "id": 5158,
    "slug": "10-dicas-para-ter-sucesso-no-seu-marketing-imobilia",
    "title": "10 Dicas para ter sucesso no seu Marketing Imobiliário",
    "date": "2023-02-13",
    "excerpt": "Aqui estão 10 dicas para ajudar a obter sucesso no marketing imobiliário:",
    "cover": "/wp-content/uploads/2023/02/conceito-pessoal-da-perspectiva-da-arquitetura-da-cidade-do-predio-de-escritorios-da-arquitetura-contemporanea_53876-42940.jpg",
    "categories": [
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "10 Dicas para ter sucesso no seu Marketing Imobiliário | IMOBMEET",
    "seoDesc": "Aqui estão 10 dicas para ajudar a obter sucesso no marketing imobiliário:"
  },
  {
    "id": 1190,
    "slug": "como-sera-o-processo-de-vendas-em-2023",
    "title": "Como será o processo de vendas em 2023?",
    "date": "2022-11-04",
    "excerpt": "O que temos visto nos últimos anos é uma verdadeira migração do físico para o digital, o que nos move para entender o posicionamento adequado de incorporadoras, Loteadoras e empresas que comercializam",
    "cover": "/wp-content/uploads/2022/11/predios.png",
    "categories": [
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      },
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "Como será o processo de vendas em 2023? | IMOBMEET",
    "seoDesc": "O que temos visto nos últimos anos é uma verdadeira migração do físico para o digital, o que nos move para entender o posicionamento adequado de incorporadoras, Loteadoras e empresas que comercializam imóveis. Esse artigo não é uma afirmação única mas uma discussão de possibilidades baseadas em acontecimentos nos últimos anos. Para projetar seu processo [&hellip;]"
  },
  {
    "id": 1187,
    "slug": "a-importancia-de-um-processo-de-vendas-estruturado",
    "title": "A Importância de um processo de vendas estruturado",
    "date": "2022-11-04",
    "excerpt": "O mercado está cada vez mais evolutivo e transformador e algumas empresas estão ansiosas para ajustar suas estratégias de vendas. Pense nelas como um caminho a ser trilhado por sua equipe e este camin",
    "cover": "/wp-content/uploads/2022/11/processo-de-vendas.jpeg",
    "categories": [
      {
        "name": "Vendas",
        "slug": "vendas"
      }
    ],
    "seoTitle": "A Importância de um processo de vendas estruturado | IMOBMEET",
    "seoDesc": "O mercado está cada vez mais evolutivo e transformador e algumas empresas estão ansiosas para ajustar suas estratégias de vendas. Pense nelas como um caminho a ser trilhado por sua equipe e este caminho levará para uma jornada de sucesso. Com as estratégias de vendas certas, sua organização terá o poder de manter uma mentalidade [&hellip;]"
  },
  {
    "id": 1153,
    "slug": "quais-sao-as-fases-de-um-lancamento-imobiliario-estrategico",
    "title": "Quais são as fases de um lançamento imobiliário estratégico",
    "date": "2022-10-14",
    "excerpt": "Uma estratégia bem definida para um lançamento imobiliário pode ser o fator decisivo para um bom resultado em vendas na largada. Muitas empresas erram na construção de uma estratégia sólida ao contrat",
    "cover": "/wp-content/uploads/2022/10/lancamento-imobilario.jpeg",
    "categories": [
      {
        "name": "Lançamento imobiliário",
        "slug": "lancamento-imobiliario"
      }
    ],
    "seoTitle": "Quais são as fases de um lançamento imobiliário estratégico | IMOBMEET",
    "seoDesc": "Uma estratégia bem definida para um lançamento imobiliário pode ser o fator decisivo para um bom resultado em vendas na largada. Muitas empresas erram na construção de uma estratégia sólida ao contratar empresas que não são especialistas em marketing imobiliário o que pode gerar um grande prejuízo. Existes algumas fases que são bases fundamentais para [&hellip;]"
  },
  {
    "id": 1130,
    "slug": "gleybiony-camargo-ceo-do-imobmeet-no-construsummit-2022",
    "title": "Gleybiony Camargo, CEO do Imobmeet no Construsummit 2022",
    "date": "2022-09-13",
    "excerpt": "Para quem não conhece o ConstruSummit é um dos maiores eventos quando se trata da Construção Civil a nível nacional. Nesse ano de 2022 ele será realizado em Florianópolis na sede da Softplan nos dias ",
    "cover": "/wp-content/uploads/2022/09/post-blog.jpg",
    "categories": [
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Eventos",
        "slug": "eventos"
      }
    ],
    "seoTitle": "Gleybiony Camargo, CEO do Imobmeet no Construsummit 2022 | IMOBMEET",
    "seoDesc": "Para quem não conhece o ConstruSummit é um dos maiores eventos quando se trata da Construção Civil a nível nacional. Nesse ano de 2022 ele será realizado em Florianópolis na sede da Softplan nos dias 14 e 15 de Setembro, e irá contar com grandes nomes do mercado imobiliário nacional como:&#8211; José Carlos Martins (Presidente [&hellip;]"
  },
  {
    "id": 973,
    "slug": "como-utilizar-videoconferencia-no-seu-e-commerce-para-atendimento-em-tempo-real",
    "title": "Como utilizar videoconferência no seu e-commerce para atendimento em tempo real",
    "date": "2022-08-30",
    "excerpt": "O volume de vendas no e-commerce Brasileiro disparou desde 2020, é um um crescimento ascendente e evolutivo. Muitas empresas iniciaram seu processo de evolução de plataforma, organização do seu proces",
    "cover": "/wp-content/uploads/2022/08/atendimento-online-e-commerce.webp",
    "categories": [
      {
        "name": "E-commerce",
        "slug": "e-commerce"
      }
    ],
    "seoTitle": "Como utilizar videoconferência no seu e-commerce para atendimento em tempo real | IMOBMEET",
    "seoDesc": "O volume de vendas no e-commerce Brasileiro disparou desde 2020, é um um crescimento ascendente e evolutivo. Muitas empresas iniciaram seu processo de evolução de plataforma, organização do seu processo comercial, melhoria do Marketing e Branding da empresa, e algumas esqueceram de evoluir o atendimento online ou suporte ao cliente. Com a videoconferência em alta, [&hellip;]"
  },
  {
    "id": 968,
    "slug": "integrando-seu-atendimento-online-ao-seu-crm-de-vendas",
    "title": "Integrando seu atendimento online ao seu CRM de vendas",
    "date": "2022-08-30",
    "excerpt": "Seu a sua tecnologia de atendimento online não está integrada ao seu CRM de vendas, isso é uma péssima notícia. Mas calma, eu tenho uma solução que pode te ajudar. Sabe-se que cada dia mais os cliente",
    "cover": "/wp-content/uploads/2021/08/AdobeStock_430189577-scaled.jpeg",
    "categories": [
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      }
    ],
    "seoTitle": "Integrando seu atendimento online ao seu CRM de vendas | IMOBMEET",
    "seoDesc": "Seu a sua tecnologia de atendimento online não está integrada ao seu CRM de vendas, isso é uma péssima notícia. Mas calma, eu tenho uma solução que pode te ajudar. Sabe-se que cada dia mais os clientes querem ser atendidos de forma digital e online, para poderem fazer mais de uma coisa ao mesmo tempo [&hellip;]"
  },
  {
    "id": 920,
    "slug": "o-o-que-e-e-como-funciona-um-plantao-digital-de-imoveis-online",
    "title": "O que é, e como funciona um plantão digital de imóveis online?",
    "date": "2022-08-30",
    "excerpt": "Em 2020 houve uma evolução na forma em como as pessoas utilizam variados tipos de tecnologia, facilitando a inclusão de formas de atendimento online que antes não se via, o que colaborou para a evoluç",
    "cover": "/wp-content/uploads/2021/08/AdobeStock_141545283.jpg",
    "categories": [
      {
        "name": "Apresentação de imóveis online",
        "slug": "apresentacao-de-imoveis-online"
      },
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Videoconferência",
        "slug": "videoconferencia"
      }
    ],
    "seoTitle": "O que é, e como funciona um plantão digital de imóveis online? | IMOBMEET",
    "seoDesc": "Em 2020 houve uma evolução na forma em como as pessoas utilizam variados tipos de tecnologia, facilitando a inclusão de formas de atendimento online que antes não se via, o que colaborou para a evolução do mercado imobiliário e outros. O que é um Plantão Digital de imóveisAssim como se tem um stand de vendas [&hellip;]"
  },
  {
    "id": 918,
    "slug": "videoconferencia-no-atendimento-online-a-clientes",
    "title": "Videoconferência no atendimento online a clientes",
    "date": "2022-08-30",
    "excerpt": "A videoconferência passou a fazer parte do dia a dia das pessoas após a pandemia de uma forma muito mais aceita e praticada. Trazer essa solução/tecnologia de videoconferência para o atendimento a cli",
    "cover": "/wp-content/uploads/2022/08/atendimento-online-imobmeet.jpeg",
    "categories": [
      {
        "name": "Atendimento online",
        "slug": "atendimento-online"
      },
      {
        "name": "Videoconferência",
        "slug": "videoconferencia"
      }
    ],
    "seoTitle": "Videoconferência no atendimento online a clientes | IMOBMEET",
    "seoDesc": "A videoconferência passou a fazer parte do dia a dia das pessoas após a pandemia de uma forma muito mais aceita e praticada. Trazer essa solução/tecnologia de videoconferência para o atendimento a clientes é uma ótima escolha para quem quer trazer a possibilidade de um atendimento com mais empatia. Atualmente existem várias soluções de videoconferência [&hellip;]"
  },
  {
    "id": 903,
    "slug": "apresentacao-de-imoveis-online-atraves-de-videoconferencia",
    "title": "Apresentação de imóveis online através de videoconferência",
    "date": "2022-08-30",
    "excerpt": "O mundo vive a era das apresentações online, até porque tudo deve ser apresentado antes de ser vendido. Porém, após o ano de 2020 ouve uma grande evolução nos meios de comunicação e uma aceleração da ",
    "cover": "/wp-content/uploads/2021/09/imobmeet-plantao-digital.jpg",
    "categories": [
      {
        "name": "Apresentação de imóveis online",
        "slug": "apresentacao-de-imoveis-online"
      }
    ],
    "seoTitle": "Apresentação de imóveis online através de videoconferência | IMOBMEET",
    "seoDesc": "O mundo vive a era das apresentações online, até porque tudo deve ser apresentado antes de ser vendido. Porém, após o ano de 2020 ouve uma grande evolução nos meios de comunicação e uma aceleração da utilização da tecnologia em todos os setores. E no mercado imobiliário não foi diferente. Com a pandemia e a [&hellip;]"
  }
];

export const postsBySlug = Object.fromEntries(posts.map((p) => [p.slug, p]));

export const categories = (() => {
  const seen = new Map();
  for (const p of posts) for (const c of p.categories) if (!seen.has(c.slug)) seen.set(c.slug, c);
  return [...seen.values()].sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
})();
